import { IReferenceCandidateForm } from '../../../../common/models/reference/IReferenceCandidateForm';

export const getReferenceProgress = (reference: IReferenceCandidateForm) => {
  if (reference?.workInCompany) return 1;
  if (reference?.phoneNumber || reference?.email) return 0.75;
  if (reference?.type) return 0.5;
  if (reference?.firstName) return 0.25;
  return 0;
};
